import { ReadPeriodoDto } from '@/api.types';
import { DiasEntreDuasDatas } from '@/shared/utils/datas';
import { PERIODO_REGRAS_LIMITES } from './periodo-regras.utils';

export function diasDoPeriodo(periodo: ReadPeriodoDto): number {
  return Number(
    DiasEntreDuasDatas(periodo.data_inicial, periodo.data_final),
  );
}

/** Ordena registros do mais antigo para o mais novo (data inicial). */
export function ordenarPeriodosPorDataInicial(
  registros: ReadPeriodoDto[],
): ReadPeriodoDto[] {
  return [...registros].sort(
    (a, b) =>
      new Date(a.data_inicial).getTime() - new Date(b.data_inicial).getTime(),
  );
}

/**
 * Retorna o saldo de dias disponíveis do abono especial no ano.
 */
export function calcularDiasDisponiveisAbonoEspecial(
  registrosOrdenadosNoAno: ReadPeriodoDto[],
): number {
  const diasUsados = registrosOrdenadosNoAno.reduce(
    (total, periodo) => total + diasDoPeriodo(periodo),
    0,
  );

  return Math.max(
    0,
    PERIODO_REGRAS_LIMITES.maximoDiasAbonoEspecial - diasUsados,
  );
}

/**
 * Retorna o saldo de dias disponíveis de férias no período aquisitivo.
 */
export function calcularDiasDisponiveisFerias(
  registrosNoPeriodoAquisitivo: ReadPeriodoDto[],
): number {
  const diasUsados = registrosNoPeriodoAquisitivo.reduce(
    (total, periodo) => total + diasDoPeriodo(periodo),
    0,
  );

  return Math.max(
    0,
    PERIODO_REGRAS_LIMITES.maximoDiasFerias - diasUsados,
  );
}
